<div class="double-row-container" tourAnchor="search-form">

  <!-- First Row -->
  <div class="first-row flex-row flex-direction-space-between flex-align-center">
    <div class="mat-heading-field">Search Suppliers</div>

    <div class="slide-toggle-container" tourAnchor="search-toggle">
      <span class="label-left mat-caption mat-toggle-caption"
      matTooltip="'My Suppliers' searches within your network of suppliers.">My Suppliers</span>
      <mat-slide-toggle (click)="toggleChange()" class="supplier-toggle"
      [checked]="isExostarSupplier"></mat-slide-toggle>
      <span class="label-right mat-caption mat-toggle-caption"
      matTooltip="'Exostar Suppliers' searches within all Exostar suppliers.">Exostar Suppliers</span>

    </div>

    <!-- Form with Input Fields -->

    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" tourAnchor="search-criteria">
      <span id="search-fields-hint" class="visually-hidden">At least one field is required</span>

      <mat-form-field class="p-0 custom-label mr-03" >
        <mat-label class="mat-label" >Organization Name<span class="red-text" aria-hidden="true">*</span></mat-label>
        <input matInput class="mat-input-field align-input-field" type="text" formControlName="name" aria-describedby="search-fields-hint">
      </mat-form-field>
      <mat-form-field class="custom-label">
        <mat-label class="mat-label">DUNS Number<span class="red-text" aria-hidden="true">*</span></mat-label>
        <input matInput class="mat-input-field align-input-field" type="text" formControlName="dunsNumber" aria-describedby="search-fields-hint">
      </mat-form-field>

      <mat-form-field class="custom-label">
        <mat-label class="mat-label">Exostar ID<span class="red-text" aria-hidden="true">*</span></mat-label>
        <input matInput class="mat-input-field align-input-field" type="text" formControlName="exostarId" aria-describedby="search-fields-hint">
      </mat-form-field>

      <mat-form-field class="custom-label">
        <mat-label class="mat-label">US Federal Tax ID<span class="red-text" aria-hidden="true">*</span></mat-label>
        <input matInput class="mat-input-field align-input-field" type="text" formControlName="usTaxId" aria-describedby="search-fields-hint">
      </mat-form-field>

      <button class="search-button ml-20 button-text" mat-raised-button color="success" tourAnchor="complete-search"
      [disabled]="formGroup.invalid">SEARCH</button>
    </form>
    @if (!ispanel) {
      <div>
        <mat-icon svgIcon="down" class="pointer-cursor" (click)="expansionPanel()"></mat-icon>
      </div>
    } @else {
      <div>
        <mat-icon svgIcon="right" class="pointer-cursor" (click)="expansionPanel()"></mat-icon>
      </div>
    }
  </div>

  <!-- Second Row with Input Text Fields -->
  @if (!ispanel) {
    <div class="second-row d-flex flex-direction-space-between" >
      <form [formGroup]="formGroup" class="optional-fields d-flex" (ngSubmit)="onSubmit()" >

        <mat-form-field class="mr-10">
          <mat-label class="mat-label country-label">Country</mat-label>

          <mat-select class="mat-input-field" formControlName="country">
            @for (item of countryList; track item) {
              <mat-option [value]="item.name">{{ item.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field class="mr-10">
          <mat-label class="mat-label">Address #1</mat-label>
          <input matInput class="mat-input-field" type="text" formControlName="address1">
        </mat-form-field>

        <mat-form-field class="mr-10">
          <mat-label class="mat-label">Address #2</mat-label>
          <input matInput class="mat-input-field" type="text" formControlName="address2">
        </mat-form-field>

        <mat-form-field class="mr-10">
          <mat-label class="mat-label">City</mat-label>
          <input matInput class="mat-input-field" type="text" formControlName="city">
        </mat-form-field>
        <mat-form-field class="mr-10">
          <mat-label class="mat-label">State</mat-label>
          <input matInput class="mat-input-field" type="text" formControlName="state">
        </mat-form-field>
        <mat-form-field class="mr-10">
          <mat-label class="mat-label">Postal Code</mat-label>
          <input matInput class="mat-input-field" type="text" formControlName="zip">
        </mat-form-field>

      </form>
    </div>
  }
</div>